import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbLink from './breadcrumb-link';

const Breadcrumbs = ({ links }) => {
  return (
    <nav
      className="breadcrumbs"
      itemScope
      itemType="https://schema.org/BreadcrumbList"
      aria-label="Brødsmulesti"
    >
      <ol>
        {links &&
          links.map((link, index) => {
            const isLast = index == links.length - 1;

            return (
              (!isLast || index == 0) && (
                <>
                  {index > 0 && <span>&gt;</span>}
                  <BreadcrumbLink isLast={isLast} link={link} />
                </>
              )
            );
          })}
      </ol>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(BreadcrumbLink.propTypes)
};

export default Breadcrumbs;
